package com.essntl.core.settings.ui

import com.essntl.core.settings.domain.model.configuration.ConfigurationCurrencyModel

sealed interface AllowedCurrenciesEvent {
    data object GetAllowedCurrencies : AllowedCurrenciesEvent
    data class UpdateAllowedCurrencies(val c: ConfigurationCurrencyModel) : AllowedCurrenciesEvent
    data class DeleteCurrency(val c: String) : AllowedCurrenciesEvent
    data class DefaultCurrency(val c: String) : AllowedCurrenciesEvent
}